const COMPONENT_NAME = "SelectorRadioButtonGroup";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: invalid props`;
const MISSING_LEGEND_WARNING = `${COMPONENT_NAME}-warning: neither 'accessibleLegendText' nor 'ariaLabelledby were provided, the component may not meet accessibility standards`;
const MISSING_ARIA_LABEL_PREFIX_WARNING = `${COMPONENT_NAME}-warning: 'ariaLabelErrorPrefix' must be provided when 'errorText' is provided, the component may not meet accessibility standards`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR,
  MISSING_ARIA_LABEL_PREFIX_WARNING,
  MISSING_LEGEND_WARNING
};
